/**
 * @author    Wolfgang Kowarschick <kowa@hs-augsburg.de>
 * @copyright 2017
 * @license   CC-BY-NC-SA-4.0
 */

let evens = [0, 2, 4, 6, 8],
    odds  = evens.map(langer_parameter_name => langer_parameter_name + 1),
    pairs = evens.map(v => ({ even: v, odd: v + 1 }));

let name = "Anna";

console.log(evens);
console.log(odds);
console.log(pairs);
console.log(`Hello ${name}!`);